import React from 'react'
import PropTypes from 'prop-types'
import Modal from 'react-modal'
import YouTube from 'react-youtube'

import Icon from 'Pods/Shared/Icon/Icon'

function VideoModal(props) {
  const opts = {
    width: '95%',
    height: '100%',
    playerVars: {
      autoplay: 1,
    },
  }

  return (
    <Modal
      isOpen={props.modalIsOpen}
      shouldCloseOnOverlayClick
      onRequestClose={props.closeModal}
      contentLabel="Modal"
      ariaHideApp={false}
      className={{
        base: '',
        afterOpen: 'overlay-modal--container_after-open overlay-modal-container--large-closable',
        beforeClose: 'overlay-modal--container_before-close',
      }}
      overlayClassName={{
        base: 'overlay-modal--background',
        afterOpen: 'overlay-modal--background_after-open',
        beforeClose: 'overlay-modal--background_before-close',
      }}
    >
      <div className="overlay-modal overlay-modal--dark-bg">
        <button className="btn btn-transparent overlay-modal--close-inner" onClick={props.closeModal}>
          <Icon type={['fal', 'times']} color="grey-dark" />
        </button>
        <div className="overlay-modal--video-preview">
          <div className="l-inner-large">
            <span className="u-block u-text-center">
              <YouTube
                videoId={props.videoId}
                opts={opts}
              />
            </span>
          </div>
        </div>
      </div>
    </Modal>
  )
}

VideoModal.propTypes = {
  modalIsOpen: PropTypes.bool.isRequired,
  closeModal: PropTypes.func.isRequired,
  videoId: PropTypes.string.isRequired,
}

export default VideoModal
